import {
  Text,
  withDatasourceCheck,
  ImageField,
  LinkField,
  Item,
  Field,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentWithContextProps } from 'lib/component-props';
import { useMemo } from 'react';
import useHelpers from 'src/hooks/helpers';
import ScLink from 'components/Generic/SitecoreWrappers/ScLink';

type VectorTileItem = Item & {
  fields: {
    link: LinkField;
  };
};
type Fields = {
  heading: Field<string>;
  description: Field<string>;
  icon: ImageField;
  items: VectorTileItem[];
  id: string;
};

type VectorTileProps = ComponentWithContextProps & {
  fields: Fields;
};

const VectorTile = ({ fields, rendering, sitecoreContext }: VectorTileProps): JSX.Element => {
  const getExistingLinks = useMemo(() => {
    const links = fields.items || [];
    return links.filter(
      (link) => (link && link.fields.link.value.text) || sitecoreContext.pageEditing
    );
  }, [fields.items, sitecoreContext.pageEditing]);
  const { anchorId } = useHelpers(rendering);
  return (
    <div
      id={anchorId}
      className="vector-tile w-100 py-5 px-3 d-flex flex-column background-digital-deep-grey"
    >
      <div className="vector-dots flex-shrink-0 mb-5" />
      <div className="vector-tile__body text-white d-flex flex-column flex-grow-1">
        {fields.heading && (
          <Text field={fields.heading} tag="h3" className="vector-tile__heading" />
        )}
        {fields.description && (
          <Text field={fields.description} tag="p" className="vector-tile__description mt-2" />
        )}
        <div className="d-flex flex-column pt-5">
          {getExistingLinks.map((link, index) => (
            <div key={index} className={index + 1 !== getExistingLinks.length ? 'mb-2' : ''}>
              <ScLink
                field={link.fields.link}
                role="button"
                className="text-white revert-underline text-link vector-tile-link"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default withDatasourceCheck()<VectorTileProps>(VectorTile);
